/**
 * Academy Reducers
 */
 import {
    ALL_ACADEMYS,
    ADD_ACADEMY,
    ACADEMY_ACTION,
    EDIT_ACADEMY,
    STATUS_ACADEMY,
    DELETE_ACADEMY
} from 'Actions/types';

/**
 * initial auth user
 */
const INIT_STATE = {
    academylists:[],
    loading: false
};

export default (state = INIT_STATE, action) => {
    switch (action.type) {
        
        case ACADEMY_ACTION:
            return { ...state, loading: true };

        case ALL_ACADEMYS:
            return { ...state, loading: false, academylists: action.payload };  
            
        case ADD_ACADEMY:
            return { ...state, loading: false }; 
        
        case EDIT_ACADEMY:
            return { ...state, loading: false };  
        
        case STATUS_ACADEMY:
            return { ...state, loading: false };    
        
        case DELETE_ACADEMY:
            return { ...state, loading: false };   

        default: return { ...state };
    }
}